import AuthUser from '@/models/auth/auth-user.model';
import AuthRememberPassword from '@/models/auth/auth-remember-password.model';
import AuthRecoveryPassword from '@/models/auth/auth-recovery-password.model';
import HttpService from "@/services/HttpServices";

export class AuthService extends HttpService {
  public async login(user: AuthUser) {
    return (await this.post<AuthUser>(`${process.env.VUE_APP_API_URI}/users/login`, user));
  }

  public async getToken(username: Object) {
    return (await this.post<Object>(`${process.env.VUE_APP_API_URI}/users/email`, username));
  }

  public async rememberPassword(user: AuthRememberPassword) {
    return (await this.post<AuthUser>(`${process.env.VUE_APP_API_URI}/users/password-recovery`, user));
  }

  public async recoveryPassword(user: AuthRecoveryPassword) {
    return (await this.post<AuthUser>(`${process.env.VUE_APP_API_URI}/users/password-recovery-confirmation`, user));
  }
}

export default new AuthService();
